import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTrimOnFocusout]',
  standalone: false
})
export class TrimOnFocusoutDirective {

  constructor(private ngControl: NgControl) { }

  @HostListener('blur')
  onBlur(): void {
    const value = this.ngControl?.control?.value;
    this.ngControl?.control?.setValue(value?.trim());
  }
}
